export enum FilterLabel {
  MovementType = 'Tipo de movimentação',
  DatePeriod = 'Período',
  PortfolioId = 'Carteira'
}
